import React from 'react';
import MenuButton from './MenuButton';
import Screen from './Screen';

const MenuButtonGroup = (props) => {
    const { radio, ModuleRP } = props;

    return (
        <div className="col-5 ml-4">
            <Screen radio={radio} ModuleRP={ModuleRP} />
            <div className="row">
                <div className="btn_middle_menu col text-center">
                    <MenuButton direction={'gauche'} radio={radio} />
                    <MenuButton direction={'centre'} radio={radio} />
                    <MenuButton direction={'droite'} radio={radio} />
                </div>
            </div>
        </div>
    );
};

export default MenuButtonGroup;
